import { render, staticRenderFns } from "./TotalSubmitterGauge.vue?vue&type=template&id=3a4c7ffe&scoped=true"
import script from "./TotalSubmitterGauge.vue?vue&type=script&lang=js"
export * from "./TotalSubmitterGauge.vue?vue&type=script&lang=js"
import style0 from "./TotalSubmitterGauge.vue?vue&type=style&index=0&id=3a4c7ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c7ffe",
  null
  
)

export default component.exports